import React, { useState, useEffect } from 'react';
import './Visit.css';

const Calendar = ({ visitType, onSelectDays }) => {
  const [selectedDays, setSelectedDays] = useState([]);

  useEffect(() => {
    onSelectDays(selectedDays); // Send selectedDays to the parent component whenever it changes
  }, [selectedDays, onSelectDays]);

  const renderDays = () => {
    const days = [];
    const today = new Date();

    for (let i = 0; i < 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'long' });
    //   const fullDate = `${month} ${day}`;
      const fullDate = `${day}`;

      days.push(
        <div
          key={fullDate}
          className={`day ${selectedDays.includes(fullDate) ? 'selected' : ''}`}
          onClick={() => toggleDay(fullDate)}
        >
          {day}
        </div>
      );
    }

    return days;
  };

  const toggleDay = (day) => {
    setSelectedDays((prev) => {
      if (prev.includes(day)) {
        return prev.filter((d) => d !== day);
      }
      return [...prev, day];
    });
  };

  return (
    <>
      {visitType === 'Monthly' && (
        <div className="calendar">
          <h2>Select a Day</h2>
          <div className="days">{renderDays()}</div>
          <p>Selected Days: {selectedDays.join(', ')}</p>
        </div>
      )}
    </>
  );
};

export default Calendar;